module.exports = __webpack_public_path__ + "images/for_company_page/icon_operator_abccb7c1b5c6bb2e97af77bbab6aa3e0.svg";